<!-- @format -->

<span class="tiny-badge {{ flowState ? getBadgeClass() : variant || 'secondary' }} {{ customClasses || '' }}">
  {{ content }}
  <ng-content></ng-content>
</span>
